module.exports = __webpack_public_path__ + "img/Trans-Poses_0002_Queenie.186e3247.png";